<script lang="ts">
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import MediaPlayerComponent from 'src/components/MediaPlayerComponent.svelte';
	import ThermostatsG2 from 'src/components/DevicesSettings/Settings/SettingsG2/ThermostatsWallDisplay/ThermostatsG2.svelte';
	import WallDisplayThermostatAlerts from 'src/components/DevicesSettings/Settings/SettingsG2/ThermostatsWallDisplay/Components/WallDisplayThermostatAlerts.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import SidepanelStatusPeek from 'src/components/Sidepanel/SidepanelStatusPeek.svelte';
	import type { Device } from 'src/types/Device.ts';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from '@devices/index';
	import {
		getGen1DeviceStatuses,
	} from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import {
		peekOnlyStatusSlots,
		resolveSidepanelStatusSlots,
		WALL_DISPLAY_THERMOSTAT_PEEK_EXCLUDE,
	} from 'src/helpers/sidepanel_status_slots';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: isThermostat = device?.category === 'thermostat';
	$: resolvedSlots = resolveSidepanelStatusSlots(device, _statuses);
	$: statusSlots = peekOnlyStatusSlots(resolvedSlots, {
		excludeNames: isThermostat ? WALL_DISPLAY_THERMOSTAT_PEEK_EXCLUDE : [],
	});
	$: showStatusPeek = statusSlots.peek.length > 0;
</script>

<DeviceViewStateWrapper {device} hideSlotFloatingBottom={!showStatusPeek}>
	<div slot="staticTop">
		<DeviceNotificationLabel deviceId={device?.id} />
		{#if isThermostat}
			<WallDisplayThermostatAlerts {device} {status} />
		{/if}
	</div>
	<!-- Wall Display with extracted peripheral (media player or thermostat) -->
	<div class="flex-fill-space min-height-0" slot="content">
		{#if isThermostat}
			<div class="flex-full-height d-flex flex-direction-column">
				<ThermostatsG2 {device} variant="extractedMain" />
			</div>
		{/if}
		{#if device?.category === 'media_player'}
			<div
				class="extracted-wd-media flex-fill-space d-flex flex-direction-column min-height-0"
				class:has-peek={showStatusPeek}
			>
				<MediaPlayerComponent {device} compact={true} />
			</div>
		{/if}
	</div>
	<svelte:fragment slot="floatingBottom">
		{#if showStatusPeek}
			<SidepanelStatusPeek showMain={false} main={statusSlots.main} peek={statusSlots.peek} />
		{/if}
	</svelte:fragment>
</DeviceViewStateWrapper>

<style>
	.extracted-wd-media {
		height: 100%;
	}

	.extracted-wd-media.has-peek {
		padding-bottom: var(--sidepanel-floating-fade-height, 88px);
		box-sizing: border-box;
	}

	.extracted-wd-media :global(.media-player-compact-host) {
		flex: 1 1 auto;
		min-height: 0;
		height: 100%;
	}
</style>
